/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListForumCategories200ResponseDataInner } from './ListForumCategories200ResponseDataInner';
import {
    ListForumCategories200ResponseDataInnerFromJSON,
    ListForumCategories200ResponseDataInnerFromJSONTyped,
    ListForumCategories200ResponseDataInnerToJSON,
    ListForumCategories200ResponseDataInnerToJSONTyped,
} from './ListForumCategories200ResponseDataInner';

/**
 * 
 * @export
 * @interface ListForumCategories200Response
 */
export interface ListForumCategories200Response {
    /**
     * 
     * @type {Array<ListForumCategories200ResponseDataInner>}
     * @memberof ListForumCategories200Response
     */
    data?: Array<ListForumCategories200ResponseDataInner>;
}

/**
 * Check if a given object implements the ListForumCategories200Response interface.
 */
export function instanceOfListForumCategories200Response(value: object): value is ListForumCategories200Response {
    return true;
}

export function ListForumCategories200ResponseFromJSON(json: any): ListForumCategories200Response {
    return ListForumCategories200ResponseFromJSONTyped(json, false);
}

export function ListForumCategories200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListForumCategories200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ListForumCategories200ResponseDataInnerFromJSON)),
    };
}

export function ListForumCategories200ResponseToJSON(json: any): ListForumCategories200Response {
    return ListForumCategories200ResponseToJSONTyped(json, false);
}

export function ListForumCategories200ResponseToJSONTyped(value?: ListForumCategories200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ListForumCategories200ResponseDataInnerToJSON)),
    };
}

